// pages/DoctorTeam.jsx
import team2 from '../Assets/TeamandOthers/Team2.webp'
import team3 from '../Assets/TeamandOthers/Team3-1.webp'
import team4 from '../Assets/TeamandOthers/Team4.webp'
import team5 from '../Assets/TeamandOthers/Team5.webp'
import team6 from '../Assets/TeamandOthers/Team6.webp'
import team7 from '../Assets/TeamandOthers/Team11-1.webp'


const groupImages = [
  {
    src: team2,
    alt: "Our dental team with a happy patient in the clinic",
    caption: "Caring for smiles together – our dedicated team in action",
  },
  {
    src: team3,
    alt: "Full dental team posing in professional attire",
    caption: "United expertise – the complete Smile Dental family",
  },
  {
    src: team4,
    alt: "Team of doctors standing together with confidence",
    caption: "Committed professionals ready to serve you",
  },
  {
    src: team5,
    alt: "Dental team with arms crossed in modern clinic",
    caption: "Strength in unity – our Vijayawada dental experts",
  },
  {
    src: team6,
    alt: "Large group of dental staff in clinic reception",
    caption: "The entire team welcoming you to our practice",
  },
];

export default function DoctorTeam() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      {/* Hero Group Photo */}
      <div className="relative">
        <div className="h-[500px] md:h-[650px] lg:h-[750px] overflow-hidden">
          <img
            src={team7}
            alt="Our entire dental team smiling together in the clinic"
            className="w-full h-full object-cover object-center brightness-90"
          />
          {/* <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/40 to-transparent" /> */}
        </div>

        {/* Overlay Text */}
        <div className="absolute inset-0 flex items-center justify-center text-center px-6">
          <div className="max-w-5xl">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white drop-shadow-2xl mb-4 md:mb-6 mt-[15%]">
              Our United Dental Team
            </h1>
            <p className="text-lg md:text-2xl text-white/95 max-w-4xl mx-auto drop-shadow-lg leading-relaxed">
              A passionate group of specialists working together in Vijayawada to provide gentle, advanced, and personalized dental care for every patient.
            </p>
          </div>
        </div>
      </div>

      {/* Team Gallery Section */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20 py-16 md:py-24">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-5">
            Moments from Our Team
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            See our team collaborating, caring, and creating beautiful smiles every day.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6 md:gap-8">
          {groupImages.map((image, idx) => (
            <div
              key={idx}
              className="group relative rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300"
            >
              <img
                src={image.src}
                alt={image.alt}
                className="w-full h-80 md:h-96 object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-70 group-hover:opacity-90 transition-opacity duration-300" />
              <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                <p className="text-base md:text-lg font-medium drop-shadow-md">
                  {image.caption}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div className="text-center mt-16 md:mt-20">
          <p className="text-gray-700 text-lg mb-6">
            Want to meet our warm and welcoming team in person?
          </p>
          <a
            href="/take-a-tour"
            className="inline-block bg-blue-600 text-white px-10 py-5 rounded-full font-semibold hover:bg-blue-700 transition shadow-xl hover:shadow-2xl text-lg"
          >
            Take a Virtual Clinic Tour →
          </a>
        </div>
      </div>
    </div>
  );
}